module.exports = __webpack_public_path__ + "img/tf-cb-n1.205424d1.gif";